import { EventEmitter } from 'events';
import assign from 'object-assign';

import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'change';
const EQUIPMENT_FORM_CHANGE = 'add-equipment';
const BULK_EQUIPMENT_FORM_CHANGE = 'bulk-equipment-form-change';

let formStatus = {};
let createdEquipment = null;
let createEquipmentError = null;
let equipmentPayload = {
  equipment: [],
  pages: 1,
  total: 0,
};

let bulkUpdateResult = {
  successes: [],
  errors: [],
};

let audits = {};

const EquipmentStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  emitEquipmentFormChange() {
    this.emit(EQUIPMENT_FORM_CHANGE);
  },

  emitBulkUpdateChange() {
    this.emit(BULK_EQUIPMENT_FORM_CHANGE);
  },

  addBulkUpdateChangeListener(callback) {
    this.on(BULK_EQUIPMENT_FORM_CHANGE, callback);
  },

  removeBulkUpdateChangeListener(callback) {
    this.removeListener(BULK_EQUIPMENT_FORM_CHANGE, callback);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  addEquipmentFormListener(callback) {
    this.on(EQUIPMENT_FORM_CHANGE, callback);
  },

  removeEquipmentFormListener(callback) {
    this.removeListener(EQUIPMENT_FORM_CHANGE, callback);
  },

  getBulkUpdateResult() {
    return bulkUpdateResult;
  },

  getCreatedEquipment() {
    return createdEquipment;
  },

  getCreateEquipmentError() {
    return createEquipmentError;
  },

  getEquipment() {
    return equipmentPayload.equipment;
  },

  getFormStatus() {
    return formStatus;
  },

  getAudits() {
    return audits;
  },

  setFormStatus({ success, error }) {
    formStatus = {
      success,
      error,
    };
  },

  getEquipmentPayload() {
    return equipmentPayload;
  },

  setEquipmentPayload(equipment) {
    equipmentPayload = {
      equipment: equipment.items,
      pages: equipment.pages,
      total: equipment.total_entries,
    };
  },

  updateBulkUpdateResults(results) {
    const { successes, errors } = results;

    bulkUpdateResult = {
      successes,
      errors,
    };
  },

  updateEquipment(updatedEquipment) {
    if (updatedEquipment) {
      const equipmentIndex = equipmentPayload.equipment.findIndex(
        (e) => e._id === updatedEquipment._id,
      );
      if (equipmentIndex === -1) return;
      equipmentPayload.equipment = [
        ...equipmentPayload.equipment.slice(0, equipmentIndex),
        updatedEquipment,
        ...equipmentPayload.equipment.slice(equipmentIndex + 1),
      ];
    }
  },

  onGetEquipmentAudit(payload) {
    audits[payload.id] = payload.audits;
  },

  getEquipmentAuditEvents(id) {
    return audits[id];
  },
});

EquipmentStore.dispatchToken = AdminAppDispatcher.register((payload) => {
  const action = payload.action;

  switch (action.type) {
    case ActionTypes.RECEIVE_ALL_EQUIPMENT:
      EquipmentStore.setEquipmentPayload(action.equipment);
      EquipmentStore.emitChange();
      break;
    case ActionTypes.UPDATE_EQUIPMENT:
      EquipmentStore.updateEquipment(action.equipment);
      EquipmentStore.emitChange();
      EquipmentStore.setFormStatus({ success: true, error: null });
      EquipmentStore.emitEquipmentFormChange();
      break;
    case ActionTypes.BULK_UPDATE_EQUIPMENTS:
      EquipmentStore.updateBulkUpdateResults(action.results);
      EquipmentStore.emitBulkUpdateChange();
      EquipmentStore.updateEquipment(action.results.successes);
      EquipmentStore.emitChange();
      break;
    case ActionTypes.ADD_EQUIPMENT:
      equipmentPayload.equipment.push(action.equipment);
      createdEquipment = action.equipment;
      createEquipmentError = null;
      EquipmentStore.emitChange();
      EquipmentStore.setFormStatus({ success: true, error: null });
      EquipmentStore.emitEquipmentFormChange();
      break;
    case ActionTypes.ADD_EQUIPMENT_FAIL:
      createEquipmentError = action.error;
      EquipmentStore.emitChange();
      EquipmentStore.setFormStatus({ success: false, error: action.error });
      EquipmentStore.emitEquipmentFormChange();
      break;
    case ActionTypes.FETCH_EQUIPMENT_AUDIT_SUCCESS:
      EquipmentStore.onGetEquipmentAudit(action);
      EquipmentStore.emitChange();
      break;
    default:
  }
});

export default EquipmentStore;
